<template>
    <header class="app-header">
        <div class="container">
            <div class="logo">
                <img src="../../assets/logo.png" alt="">
                <div class="title">
                    <span class="title1">武汉通测科技有限公司</span>
                    <span class="title2">WUHAN TONGCE TECHNOLOGY CO.,LTD</span>
                </div>
            </div>
            <nav class="desktop-nav">
                <router-link to="/">官网首页</router-link>
                <router-link to="/about">关于我们</router-link>
                <router-link to="/products">产品中心</router-link>
                <router-link to="/news">新闻资讯</router-link>
                <router-link to="/solutions">技术服务</router-link>
                <router-link to="/contact">联系我们</router-link>
                <div style="width: 0.1875rem;height: 2.1875rem;background: #FFFFFF;"></div>
                <div class="right-nav">
                    <!-- <img src="../../assets/img/Vector.png" style="width: 1.6875rem;height: 1.6875rem;" alt="">
                    <span>027-87001617</span> -->
                    <router-link to="/management" v-if="token">后台管理</router-link>
                    <router-link to="/login" v-else>登 录</router-link>
                </div>
            </nav>
        </div>
    </header>
</template>

<script>
import router from '@/router';


export default {
    components: {
    },
    data() {
        return {
            token: sessionStorage.getItem('token')
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables';

.app-header {
    background-color: rgba(40, 69, 90, 0.6);
    padding: 0.75rem 0;
    margin-bottom: -6.526rem;
    position: relative;
    width: 100%;
    top: 0;
    z-index: 1000;

    .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .logo {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 2.5rem;

        .title {
            display: flex;
            justify-content: flex-start;
            flex-direction: column;

            .title1 {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: bold;
                font-size: 1.9375rem;
                color: #FFFFFF;
                text-align: left;
                font-style: normal;
                text-transform: none;
            }

            .title2 {
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: bold;
                font-size: 0.875rem;
                color: #FFFFFF;
                letter-spacing: 0.0625rem;
                text-align: left;
                font-style: normal;
                text-transform: none;
            }
        }

        img {
            width: 5.0625rem;
            height: 5.0625rem;
        }
    }

    .desktop-nav {
        display: flex;
        gap: 4.0625rem;

        a {
            color: rgba(255, 255, 255, 1);
            text-decoration: none;
            font-weight: 500;
            position: relative;
            font-weight: 500;
            font-size: 1.25rem;

            &:after {
                content: '';
                position: absolute;
                bottom: -2.15rem;
                left: 0;
                width: 0;
                height: 0.1875rem;
                background-color: $title-active-color;
                transition: width 0.3s;
            }

            &:hover:after,
            &.router-link-exact-active:after {
                width: 100%;
            }

            &.router-link-exact-active {
                color: $title-active-color;
            }
        }

        .right-nav {
            display: flex;
            // align-items: center;
            margin-right: 3rem;

            span {
                // margin-left: 0.625rem;
                color: rgba(255, 255, 255, 1);
                text-decoration: none;
                font-weight: 500;
                position: relative;
                font-weight: 500;
                font-size: 1.25rem;
                cursor: pointer;
            }
        }
    }
}
</style>
